import { TokenizedWord } from 'features/aiTester/store/types';
import { getWordsStats } from 'features/aiTester/utils/getTokensFromText';

export const isTextAvailable = (words: TokenizedWord[]) => {
  const { available } = getWordsStats(words ?? []);

  return available > 0;
};
